import React from 'react';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import HtmlParser from 'html-react-parser';
import { Link } from 'react-scroll';
import { DemoFormLong } from '../../../components/DemoFormLong.jsx';
import CaseStudyHero from '../../../components/CaseStudyHero';
import UserTestimonyCardNoLogo from '../../../components/cards/UserTestimonyCardNoLogo';
import JoinHappyCustomers from '../../../components/JoinHappyCustomers';
import '../../../scss/pages/_customer-story-page.scss';
import { PATHS } from '../../../utils/urls';

const Resources = (props) => {
	const location = props.location;

	return (
		<Layout  bodyClass="customer-story-page showbie-story-page" ontouchstart>
			<SEO title="Case Study: Showbie | ChartHop | People Analytics, Visualized" />
			<Helmet>
				<meta
					name="description"
					content="Showbie needed to scale the impact of their small HR team. ChartHop helped them empower business leaders with data and make data-informed people decisions."
				/>
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="Case Study: Showbie | ChartHop | People Analytics, Visualized" />
				<meta property="og:description" content="Showbie needed to scale the impact of their small HR team. ChartHop helped them empower business leaders with data and make data-informed people decisions." />
				<meta property="og:image" content={`https://www.charthop.com/landings/integration-showbie.png`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
        		<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="Case Study: Showbie | ChartHop | People Analytics, Visualized" />
				<meta name="twitter:description" content="Showbie needed to scale the impact of their small HR team. ChartHop helped them empower business leaders with data and make data-informed people decisions." />
				<meta name="twitter:image" content={`https://www.charthop.com/landings/integration-showbie.png`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />
			</Helmet>

            <CaseStudyHero
                name="Showbie"
                title="Navigating post-Series A growth"
                logo="/customers/show/showbie-logo.svg"
                titlePosition="top"
				background="/customers/customer-stories/background-hero-lines.png"
				pdfUrl="/customers/showbie-case-study.pdf"
				caseStudySource="customers-showbie-PDF-case-study-header"
            />

			<section className="sectionArrow">
			<Link to="testimonySection" smooth={true} offset={-70} duration={500}><div class="arrow bounce"></div></Link>
			</section>

			{/* USER TESTIMONY SECTION*/}
			<section className="testimonySection text-left flex-centeredColumn sectionSpacing backgroundGradientContainer-Reverse" id="Testimony">
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer"> 
					<UserTestimonyCardNoLogo
						testimony={HtmlParser('<p>"When those data pieces are consolidated to one system, it really [becomes] that living, breathing system of record for people and growth."</p>')}
						name="Colin Bramm"
						position="CEO & Co-founder @ Showbie"
						image="/customers/show/colin-bramm-showbie.jpg"
						cardColor="#FFFFFF"
					/>
				</div>
			</section>			

			{/*Before ChartHop Section */}
			<section className="before-charthop-section sectionSpacing">
				<div className="container pt-3 pb-5">					
					<div  className="row align-items-center pt-3 pt-mt-4 pt-lg-5">
						{/*Before Charthop COl */}
						<div className="col-md-7 col-lg-6">
							<div className="mr-md-2">
								<h2>Searching for a path to growth buried inside spreadsheets</h2>
								<p>Designing the future of Showbie has been top of mind for Bramm since their Series A fundraising back in August 2020, but planning out this new and exciting stage hasn’t been easy. </p>
								<p>“I was looking at our hiring plans for the next year, which were a complete spreadsheet conundrum,” Bramm admits. “It was just a total disaster of spreadsheets and timelines and Gantt charts.”</p>
								<p>Once Bramm compiled the budget, headcount, and month-over-month growth projections, he presented those figures to Showbie’s board and leadership team.</p>
								<p>As they talked through the figures, various scenarios would emerge: <i>If things are going really well for the company and we have more revenue, then I’d like to do this, or if things aren’t growing as much, then I’d like to do this but a little bit less of that</i>. But these scenarios were difficult to visualize, <b>which made alignment near impossible.</b></p>
								<p>Bramm needed his board and leadership team on the same page about Showbie’s path to growth and realized their current tools could no longer get them there. So, Bramm went searching for a solution that could make that crucial alignment possible.</p>
							</div>
						</div>

						{/* About */}
						<div className="containerAbout col-md-5 col-lg-6" >	          
							<div className="flex-centeredColumn contentBlock background-about">
								<h4 className="h4-big"><strong>About</strong></h4>
								<img src={'/customers/show/showbie-logo-white.svg'} alt="Showbie" style={{margin: `auto`, maxWidth: 200}}/>
								<h4 className="h4-big"><strong>-</strong></h4>
								<h4><strong>Founded:</strong> 2013</h4>
								<h4><strong>Industry:</strong> Education</h4>
								<h4><strong>Type:</strong> Startup</h4>
								<h4><strong>Number of Employees:</strong> 49</h4>
								<h4><strong>Number of Offices:</strong> 1</h4>
							</div><br/><br/>

							<h4 className="text-center seeking-title"><strong>Showbie was wasting:</strong></h4>
							<br/>
							<div className="flex-centeredColumn contentBlock">
								<div className="flex-platform svg-info-beforeChartHop">
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/time2.svg '} alt="Visualize" />
										<p>Time</p>
									</div>
									<div className="svg-info-card-3col2">
										<img src={'/product/org-chart/money.svg'} alt="Put a face to the name" />
										<p>Money</p>
									</div>
									<div className="svg-info-card-3col2 ">
										<img src={'/product/org-chart/productivity2.svg'} alt="Time Saving" />
										<p>Productivity</p>
									</div>        
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* USER TESTIMONY SECTION*/}
			<section className="text-left flex-centeredColumn sectionSpacing backgroundGradientContainer" id="Testimony">
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer"> 
					<UserTestimonyCardNoLogo
						testimony={<p>
							 "Between the work it saved me, and the work it saved our leadership team, we probably saved over $10,000 in lost productivity - in just one planning process." 
							</p>}
						name="Colin Bramm"
						position="CEO & Co-founder @ Showbie"
						image="/customers/show/colin-bramm-showbie.jpg"
						cardColor="#FFFFFF"
					/>
				</div>
			</section>

			{/* With ChartHop Section */}
			<section className="with-charthop-section sectionSpacing">
				<div className="container pt-3 pb-5">					
					<div className="row align-items-center pb-3 pb-md-4 pb-lg-5 pt-3 pt-mt-4 pt-lg-5">
						{/* With Charthop COl */}
						<div className="col-md-7 col-lg-6">
							<div className="mr-md-2">
								<h2>Leveraging powerful visuals and real-time collaboration to reach alignment</h2>
								<p>To grow in an ever-changing industry, Showbie needed an equally dynamic solution. That’s when an industry acquaintance introduced him to ChartHop.</p>
								<p>Right away, Bramm knew <b>ChartHop would help his board and leadership team visualize potential growth outcomes for Showbie</b>. All he had to do was plug in the numbers from his disastrous spreadsheets, and ChartHop would transform that data into immediate actionable insights.</p>
								<p>ChartHop’s ability to map multiple scenarios would allow Bramm to create and explore various futures for Showbie, like the creation of cross-functional teams or what the company would look like if various strategic hiring decisions were made. But it was the ease of creating these scenarios using drag-and-drop functionality and on-page filtering that showed Bramm how easy real-time collaboration would be once he had leadership in the same room.</p>
								<p>ChartHop integrated with and synced data daily from their human resources system, BambooHR. This gave Bramm confidence that he and the leadership team could make informed decisions about the future. <b>They knew they were working from a single source of truth.</b></p>
							</div>
						</div><br/>

						{/*Now Showbie can COl */}
						<div className="containerNow col-md-5 col-lg-6" >		          
							<div className="flex-centeredColumn contentBlock background-withCharthop">
							<h4 className="text-center"><strong>Now Showbie can:</strong></h4>
								<div className="flex-platform svg-info2-withCharthop">
									<div className="svg-info-card-3col2">
										<img src={'/customers/show/communicate.svg'} alt="Visualize" />
										<p>Communicate their vision for growth</p>
									</div>
									<div className="svg-info-card-3col2">
										<img src={'/customers/show/transparent.svg'} alt="Put a face to the name" />
										<p>Have transparent conversations</p>
									</div>
									<div className="svg-info-card-3col2 people-width">
										<img src={'/customers/show/opportunities.svg'} alt="Time Saving" />
										<p>Identify growth opportunities</p>
									</div>
									<div className="svg-info-card-3col2">
										<img src={'/customers/show/leadership.svg'} alt="Transparency" />
										<p>Align leadership to one hiring plan</p>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/*Bullets Section */}
					<div className="sectionSpacing flex-centeredColumn with-charthop-section">
						<div className="contentBlock">
							<h4 className="text-center">Before ChartHop, Bramm was <strong className="p-lightblue">tangled up in spreadsheet gymnastics</strong>, unable to align his team on his ambitious plans for Showbie’s future growth. This manually intensive process left him wondering.</h4>
							<div className="flex-centeredColumn contentBlock">
								<div className="pgc1">
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p className="text-left">How to plan amidst uncertainty?</p>
										</div>
									</div>
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p>How to build staff capacity to meet growing need?</p>
										</div>
									</div>
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p>How to communicate plans effectively?</p>
										</div>
									</div>
									<div className="pgc2">
										<div className="pgc3">
											<img src={'/product-overview/icons/checkmark_icon.svg'} alt="checkmark" />
											<p>How to leverage their funding to grow sustainably and with intention?</p>
										</div>
									</div>
								</div>
							</div>
							<p className="text-center pb-3">ChartHop didn’t just offer robust planning capabilities, it also saved the company the equivalent of $10K in lost productivity across the organization.</p>
						</div>
						<div className="">
							<center><a className="button button-withCharthop" rel="noopener noreferrer" target="_blank" href={PATHS.OVERVIEW}>START SAVING</a></center>
						</div>
					</div>
				</div>
			</section>

			{/* USER TESTIMONY SECTION */}
			<section className="text-left flex-centeredColumn sectionSpacing backgroundGradientContainer-Reverse" id="Testimony">
				<div className="contentBlock d-flex justify-content-between flex-wrap gridContainer"> 
					<UserTestimonyCardNoLogo
						testimony={<p>
							 "I think everyone who works here deserves to be part of an organization where their personal growth is fostered. And ChartHop gives us a complete picture of where we’re going and how we’re going to grow our people." 
							</p>}
						name="Colin Bramm"
						position="CEO & Co-founder @ Showbie"
						image="/customers/show/colin-bramm-showbie.jpg"
						cardColor="#FFFFFF"
					/>
				</div>
			</section>		

			{/* TRUSTED */}
			<section className="customer pt-8 pb-5">
				<JoinHappyCustomers title={HtmlParser('Trusted <span class="blue-text">by</span>')}></JoinHappyCustomers>
            </section>
			
			{/* LONG FORM */}
            <section name="request-demo" id="request-demo" className="request-demo pt-3 pb-4 pt-md-8 pb-md-8">
				<DemoFormLong source={"customers-showbie-demo-bottom"} centerContent={true} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">"The most powerful part [of planning in ChartHop] was being able to put it in front of the leadership team so there’s clarity on the plan, and being able to make changes to the scenario in real time based on feedback we discussed in the meeting.”</p><div class="authorTag"><img src="/customers/show/colin-bramm-showbie.jpg" class="testimonialAuthor" alt="Colin Bramm" /><div><p class="contactAuthor"><strong>Colin Bramm</strong> <br>CEO & Co-founder @ Showbie</p></div></div>')}/>
			</section>
		</Layout>
	);
};


export default Resources;